<template>
    <v-container>
        <div :class="{'login-container': mode == 1, 'register-container': mode == 2,}">
            <v-btn class="mt-3" text small color="primary" style="z-index: 1" :ripple="false" @click="back">
                <v-icon left>mdi-chevron-left</v-icon>
                {{ $langs.get("gen.goBack") }}
            </v-btn>
            
            <!-- Centered Box -->
            <v-container class="center-box">
                <v-container class="my-4 text-center text-h4 font-weight-bold primary--text">
                    <img 
                        style="width: 188px;"
                        src="@/assets/img/repttown_text.svg"
                        alt="Home"
                    />
                </v-container>
                <Login :toHome="toHome" v-if="mode == 1"/>
                <Register v-if="mode == 2"/>
                <!-- <ResetPassword v-if="mode == 3"/> -->
            </v-container>
        </div>
    </v-container>
</template>

<script>
import Login from "./Login.vue";
import Register from "./Register.vue";
// import ResetPassword from "./ResetPassword.vue";

export default {
    data() {
        return {
            toHome: false,
        }
    },
    components: {
        Login,
        Register,
        // ResetPassword,

    },
    methods: {
        back() {
            if (this.mode == 3)
                return this.$router.push("/login");
            this.$router.push("/");
        }
    },
    computed: {
        mode() {
            if (this.$route.path === '/login') return 1;
            if (this.$route.path === '/register') return 2;
            // if (this.$route.path === '/resetpassword') return 3;
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.toHome = (from.path.indexOf('/register') != -1 || from.path.indexOf('/resetpassword') != -1);
        });
    },
}
</script>


<style scoped>
.login-container {
    min-height: 500px;
}

.register-container {
    min-height: 900px;
}

.center-box {
    max-width: 380px;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>